import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';

const AccessViewDescription = () => {
    const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);

    return (
        <>
            <h4 className="roles-header">My Branches</h4>
            <p>To change branches click the branch name.</p>
            <div className="privilege-description">
                <Button
                    variant="link"
                    title="Privilege Description"
                    onClick={() => setIsDescriptionOpen(!isDescriptionOpen)}
                >
                    {isDescriptionOpen ? <FaCaretDown /> : <FaCaretRight />} Privilege Description
                </Button>
            </div>
            {isDescriptionOpen && (
                <ul id="div_role_description">
                    <li>
                        View Patient:
                        <small>(User will be able to only view data in the system.)</small>
                    </li>
                    <li>
                        Add Patient:
                        <small>(User will be allowed to add/edit patients in the system.)</small>
                    </li>
                    <li>
                        Conduct Activities:
                        <small>
                            (User will be allowed to perform assessments, add notes and change activity dates.)
                        </small>
                    </li>
                    <li>
                        PCC:
                        <small>(User can be notified via email about patients overdue and due this week.)</small>
                    </li>
                    <li>
                        API:
                        <small>(User will be able to use the STM API.)</small>
                    </li>
                    <li>
                        Branch Admin:
                        <small>
                            (User will be allowed to edit past assessments and can access admin area to grant/modify
                            privileges for branch users.)
                        </small>
                    </li>
                    <li>
                        Company Admin:
                        <small>
                            (User will be allowed to edit past assessments, grant/modify any user privileges(including
                            other admins) and can create system administrators.)
                        </small>
                    </li>
                </ul>
            )}
        </>
    );
};

export default AccessViewDescription;
